import baseRouteSeoSeedJson from '@/config/route-seo.json';

export type RouteCategory = 'calculator' | 'content';

export type RouteSchemaKind = 'WebPage' | 'Article' | 'FAQPage';

export type RouteSeoSeed = {
  path: string;
  title: string;
  description: string;
  category: RouteCategory;
  legacyPaths: string[];
  socialImage: string;
  schemaKinds: RouteSchemaKind[];
  hasLongFormContent: boolean;
};

function assert(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new Error(message);
  }
}

const baseRouteSeeds = baseRouteSeoSeedJson as RouteSeoSeed[];

export const routeSeoSeed: RouteSeoSeed[] = [
  ...baseRouteSeeds
];

const seenPaths = new Set<string>();
const seenTitles = new Set<string>();
for (const route of routeSeoSeed) {
  assert(route.path.startsWith('/'), `Route path must start with "/": ${route.path}`);
  assert(!seenPaths.has(route.path), `Duplicate route path found in route SEO seed: ${route.path}`);
  assert(!seenTitles.has(route.title), `Duplicate route title found in route SEO seed: ${route.title}`);
  seenPaths.add(route.path);
  seenTitles.add(route.title);
}
